import Card from '@components/card';
import Icon from '@components/icon/Icon';
import { mdiOpenInNew } from '@mdi/js';
import classNames from 'classnames';
import { Button } from '@trussworks/react-uswds';
import './sectionCard.scss';

const SectionCard = ({ buttonText, className, content, external, isDisabled, onClick = () => {}, title, url }) => {
  const handleOnClick = () => {
    if (url) {
      window.open(url, '_blank', 'noopener,noreferrer');
    } else {
      onClick();
    }
  };

  const cssClasses = classNames('section-card', className, {
    'section-card-disabled': isDisabled,
  });

  return (
    <Card className={cssClasses}>
      <h6>{title}</h6>
      <hr />
      <p>{content}</p>
      {buttonText && (
        <div className='section-card-buttons'>
          <Button type='button' outline disabled={isDisabled} onClick={handleOnClick} size='small' title={buttonText}>
            {buttonText} {external && <Icon focusable={false} path={mdiOpenInNew} size={'16px'} />}
          </Button>
        </div>
      )}
    </Card>
  );
};

export default SectionCard;
